//lib imports
import { useSelector } from "react-redux";
import { requestFaqCategories } from "src/redux/faqCategories/faqCategories.actions";
import { wrapper } from "src/redux/store";

//component imports
import Error from "./_error";
import CategoriesListing from "src/components/pages/index/CategoriesListing";
import HeadWrapper from "src/components/layouts/HeadWrapper";

//util imports
import { isEmptyObject } from "src/utils";

//style imports
import styles from "src/styles/pages/index.module.scss";
import { getFaqCategories } from "src/utils/api";
import { FAQ_CATEGORIES } from "src/redux/faqCategories/faqCategories.constants";

const Index = () => {
  //Calling hook 'useSelector' for getting state from reducer.
  const categoriesData = useSelector((state) => state.faqCategories);
  if (
    !isEmptyObject(categoriesData.payload) &&
    categoriesData.payload?.statusCode !== 200 &&
    !categoriesData.isLoading
  ) {
    return <Error statusCode={categoriesData.payload.statusCode} />;
  }

  const seoData =
    categoriesData.payload?.data &&
    categoriesData.payload?.data.SEODetails &&
    categoriesData.payload?.data.SEODetails.length &&
    categoriesData.payload?.data.SEODetails[0];

  return (
    <>
      <HeadWrapper
        title={seoData?.seoTitle || "Freecharge Support"}
        desc={seoData?.seoDescription || undefined}
        keywords={seoData?.seoKeywords || "freecharge, support"}
        canonical="https://support.freecharge.in/"
      />
      <div className={`${styles.helpTopicsSec} ${styles.container}`}>
        <div className={styles.helpHead}>
          <h1 className={styles.titleHead}>Browse Help Topics</h1>
          <p className={styles.title}>
            Choose a category and we’ll find you the best solution
          </p>
        </div>
        <div className={styles.browseCat}>
          <ul>
            <CategoriesListing categories={categoriesData.payload?.data} />
          </ul>
        </div>
      </div>
    </>
  );
};

Index.displayName = "IndexPage";

// ✅ Use `getServerSideProps` instead of `getInitialProps`
export const getServerSideProps = wrapper.getServerSideProps(
  (store) => async () => {
    const state = store.getState();
    const existingData = state.faqCategories.payload?.data;

    if (existingData && existingData.docs?.length > 0) {
      return { props: {} };
    }

    const response = await getFaqCategories();

    if (response && response?.data) {
      store.dispatch({ type: FAQ_CATEGORIES.SUCCESS, payload: response });

    }
    // ✅ Ensure Redux updates before returning
    await new Promise((resolve) => setTimeout(resolve, 100));
    const updatedState = store.getState();
    if (updatedState.faqCategories.payload?.data?.docs?.length > 0) {
      return { props: {} };
    }
    return { props: {} };
  }
);


export default Index;
